import { useState } from "react";
import ModalWindow from "../../../../../../../Components/ModalWindow/ModalWindow";
import PlayerInGameRoles from "../../../../../../../Services/Api/PlayerInGameRoles.ts";

const AddEditPlayerRole = ({setShowAddEdit, editData, roles, groupId, refresh}) => {
    const playerInGameRoles = new PlayerInGameRoles();

    const [discordId, setDiscordId] = useState(editData ? editData.discordId : "");
    const [userId, setUserId] = useState(editData ? editData.userId : "");
    const [expires, setExpires] = useState(editData ? editData.expires.split("T")[0] : new Date().toISOString());
    const [shouldExpire, setShouldExpire] = useState(editData ? editData.shouldExpire : false);
    const [inGameRoleId, setInGameRoleId] = useState(editData ? editData.inGameRoleId : roles[0].id);

    const addEdit = () => {
        let data = {
            serverGroupId: groupId,
            expires : expires,
            discordId : discordId,
            shouldExpire : shouldExpire,
            inGameRoleId: inGameRoleId,
            userId: userId
        }

        if(discordId && userId) {
            if(editData) {
                data.id = editData.id;
                playerInGameRoles.Edit(data, () => { setShowAddEdit(false); refresh() })
            }
            else{
                playerInGameRoles.Add(data, () => { setShowAddEdit(false); refresh() })
            }
        }
    }

    return (
        <ModalWindow 
            title={editData ? "Edytuj rolę użytkownika" : "Dodaj rolę użytkownika"}
            minWidth={"30%"}
            buttons={[
                { Text: editData ? "Edytuj" : "Dodaj", onClick: () => addEdit() }, 
                { Text: "Anuluj", className: "modalSecondaryBtn", onClick: () => setShowAddEdit(false)}
            ]}
            content={
                <>
                    <div className="modalField">
                        <span className="pl-1">Discord Id</span>
                        <input defaultValue={discordId} onChange={(e) => setDiscordId(e.target.value)} className="input w-full" type="text"/>
                    </div>      
                    <div className="modalField">
                        <span className="pl-1">Id użytkownika</span>
                        <input defaultValue={userId} onChange={(e) => setUserId(e.target.value)} className="input w-full" type="text"/>
                    </div>  
                    <div className="modalField">
                        <span className="pl-1">Rola</span>
                        <select defaultValue={inGameRoleId} onChange={(e) => setInGameRoleId(Number(e.target.value))} className="input">
                            {roles.map(role => 
                                <option value={role.id}>{role.roleName}</option>
                            )}
                        </select>
                    </div>
                    <div className="mt-2 mb-2"> 
                        <input checked={shouldExpire} onChange={(e) => setShouldExpire(e.target.checked)} className="" type="checkbox"/>
                        <span className="pl-1">Ma wygasnąć</span>
                    </div>     
                    { shouldExpire &&
                        <div className="modalField">
                            <span className="pl-1">Wygasa</span>
                            <input defaultValue={expires} onChange={(e) => setExpires(e.target.value)} className="input w-full" type="date"/>
                        </div>        
                    } 
   
                </>
            }
        />
    )
}

export default AddEditPlayerRole;